import request from '@/utils/request'

const addressArea = {
  name: 'addressArea',
  state: {
    isAddressAreaDetailLoading: false,
    addressAreaDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_ADDRESSAREA_DETAIL_LOADING: (state, data) => {
      state.isAddressAreaDetailLoading = data
    },
    SET_MODULES_ADDRESSAREA_DETAIL_DATA: (state, data) => {
      state.addressAreaDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryAddressAreaDetailData({ commit }, id) {
      commit('SET_IS_MODULES_ADDRESSAREA_DETAIL_LOADING', true)
      commit('SET_MODULES_ADDRESSAREA_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/addressArea/addressAreaDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_ADDRESSAREA_DETAIL_LOADING', false)
          commit('SET_MODULES_ADDRESSAREA_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_ADDRESSAREA_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetAddressAreaDetailData({ commit }) {
      commit('SET_MODULES_ADDRESSAREA_DETAIL_DATA', {})
    }
  }
}

export default addressArea
